import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Wrapper = styled.div`
  /* uploader style */
  .drag_and_drop_uploader {
    .ant-upload {
      &.ant-upload-drag {
        border-color: ${themeGet('border.3', '#E6E6E6')};
        background-color: ${themeGet('color.1', '#ffffff')};
        &:hover {
          border-color: ${themeGet('primary.0', '#194AB9')};
        }
        .ant-upload-drag-icon {
          font-size: 36px;
          line-height: 1;
          margin-bottom: 0;
          color: ${themeGet('border.3', '#E6E6E6')};
          > img {
            width: 30px;
          }
        }
        .ant-upload-text {
          margin-bottom: 0;
          font-size: 14px;
          color: ${themeGet('text.1', '#909090')};
          line-height: 18px;
          padding: 0 10px;
          span {
            text-decoration: underline;
          }
        }
      }
    }
  }
`;

export const Label = styled.h3`
  line-height: 17px;
  font-size: 14px;
  font-weight: bold;
`;

export const Preview = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 114px;
  box-shadow: 0 0 8px ${themeGet('boxShadow.2', 'rgba(0, 0, 0, 0.16)')};
  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.7;
  }
`;

export const PreviewWrapper = styled.div`
  position: relative;
  height: 114px;
  padding: 9px 14px 7px;
  border: 1px solid transparent;
  border-bottom: 1px solid ${themeGet('border.1', '#E8E8E8')};
  transition: border 0.3s ease;
  &.no-actions {
    height: 150px;
    border-bottom: 1px solid transparent;
  }
  &:hover {
    border: 1px solid ${themeGet('primary.0', '#194AB9')};
    .delete_button {
      background-color: ${themeGet('text.1', '#909090')};
      color: ${themeGet('color.1', '#ffffff')};
      &:hover {
        background-color: ${themeGet('text.1', '#909090')};
        color: ${themeGet('color.1', '#ffffff')};
      }
    }
  }
  .delete_button {
    position: absolute;
    right: 13px;
    top: 10px;
    font-size: 20px;
    padding: 0 5px;
    border-radius: 50%;
    color: ${themeGet('border.1', '#E8E8E8')};
    &:hover {
      color: ${themeGet('border.1', '#E8E8E8')};
    }
  }
  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
`;

export const PreviewInner = styled.div`
  height: 100%;
  cursor: pointer;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 10px 6px 12px;
  white-space: nowrap;
  .ant-switch {
    margin-right: 5px;
  }
  .share-tooltip {
    margin-left: auto;
    color: ${themeGet('primary.0', '#194AB9')};
  }
`;

export const LoaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 30px;
  }
`;

export const TypeIcon = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalPreviewBody = styled.div`
  padding: 127px 0 140px;
  @media only screen and (max-width: 991px) {
    padding: 100px 0;
  }
  @media only screen and (max-width: 767px) {
    padding: 70px 0;
  }
`;

export const ModalPreviewText = styled.div`
  margin-top: 10px;
  text-align: center;
  a {
    color: ${themeGet('primary.0', '#194AB9')};
    font-weight: bold;
    &: hover {
      opacity: 0.8;
    }
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Action = styled.div`
  display: flex;
  align-items: center;
  padding: 9px 10px;
  .ant-switch {
    margin-right: 7px;
  }
  .action_button {
    padding: 0 7px;
    font-size: 20px;
    color: ${themeGet('text.1', '#909090')};
    &:hover {
      color: ${themeGet('text.1', '#909090')};
    }
  }
  @media only screen and (max-width: 480px) {
    padding: 5px;
  }
  @media only screen and (max-width: 413px) {
    span {
      display: none;
    }
  }
`;
